import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { AttendanceSummaryComponent } from './attendance/attendance-summary/attendance-summary.component';
import { EventSearchPageComponent } from './event-search/event-search-page/event-search-page.component';
import { InvalidRoleComponent } from './invalid-role/invalid-role.component';
import { LoginCallbackComponent } from './login-callback/login-callback.component';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { rosterAccessGuard } from './shared/guards/roster-access.guard';
import { TrainerGuard } from './shared/guards/trainer.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'events/search',
        pathMatch: 'full',
    },
    {
        path: 'events/search',
        component: EventSearchPageComponent,
        canActivate: [AutoLoginPartialRoutesGuard, TrainerGuard],
    },
    {
        path: ':eventId/rosterView',
        component: AttendanceSummaryComponent,
        canActivate: [AutoLoginPartialRoutesGuard, TrainerGuard, rosterAccessGuard],
    },
    {
        path: 'invalid',
        component: InvalidRoleComponent,
        canActivate: [AutoLoginPartialRoutesGuard],
    },

    {
        path: 'callback',
        component: LoginCallbackComponent,
    },
    {
        path: 'notfound',
        component: NotFoundPageComponent,
    },
    {
        path: '**',
        redirectTo: '/notfound',
        pathMatch: 'full',
    },
];

export class AppRoutingModule {}
